import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Dropdown } from 'antd';
import { BiConversation } from 'react-icons/bi';
import { FaRegChartBar, FaRegCheckCircle, FaRegFlag, FaRegUser } from 'react-icons/fa';
import { MdOutlineArrowBackIosNew } from 'react-icons/md';
import { WiTime4 } from 'react-icons/wi';
import { CiMobile1, CiLaptop } from 'react-icons/ci';
import { FiTablet } from 'react-icons/fi';
import { FaTv, FaWindows, FaApple, FaLinux, FaSafari, FaChrome } from 'react-icons/fa';
import { FaBrave } from 'react-icons/fa6';
import { GoDependabot } from 'react-icons/go';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { FaChevronDown } from "react-icons/fa";
import Editor from '../Excalations/Editor.jsx';
import Activity from './Activity.jsx';
import { localurl } from '../utils.js';
import { WebSocketContext } from '../../context/WebSocketContext.jsx';
import { AdminSocket } from '../../context/WebSocketContext.jsx';

const ConversationHistory = () => {
    const { messages } = useContext(WebSocketContext);
    const { isAdminConnected, currentAdminChatId } = useContext(AdminSocket);
    const navigate = useNavigate();
    const { chatId } = useParams();
    const [chatDetails, setChatDetails] = useState(null);
    // const [activeCustomerIds, setActiveCustomerIds] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [users, setUsers] = useState([]);
    const [isResolving, setIsResolving] = useState(false);
    const [conversationId, setConversationId] = useState();
    const [isConnecting, setIsConnecting] = useState(false);

    useEffect(() => {
        const fetchChatDetails = async () => {
            try {
                const response = await axios.get(`${localurl}/escalation/chat/details/${chatId}`, {
                    headers: {
                        accept: 'application/json',
                    },
                });
                setChatDetails(response.data);
            } catch (error) {
                console.error('Error fetching chat details:', error);
            }
        };

        fetchChatDetails();
    }, [chatId]);
    // const handleAdminSocketToggle = () => {
    //     if (isConnectedToThisChat) {
    //         disconnectAdminSocket();
    //         toast.success('Disconnected from user');
    //     } else {
    //         // Reset manual disconnect flag when manually connecting
    //         resetManualDisconnect();
    //         setIsConnecting(true);
    //         connectAdminSocket(conversationId);
    //     }
    // };
    const customerId = chatDetails?.active_customer?.customer_id;
    const customerIp = chatDetails?.ip;
    
    // useEffect(() => {
    //     if (messages && messages.length > 0) {
    //         const ids = messages
    //             .filter(item => Array.isArray(item?.active_sessions))
    //             .flatMap(item => item.active_sessions)
    //             .map(session => session?.customer_id)
    //             .filter(id => id !== undefined && id !== null);
    //
    //         setActiveCustomerIds(ids);
    //     }
    // }, [messages]);

    useEffect(() => {
        if (messages && messages.length > 0 && customerIp) {
            const matchedSession = messages
                .flatMap(item => item.active_sessions || [])
                .find(session => session?.ip === customerIp);

            if (matchedSession?.chat_id) {
                setConversationId(matchedSession.chat_id);
            } else {
                setConversationId(null);
            }
        }
    }, [messages, customerIp]);

    useEffect(() => {
        const fetchCustomerDetails = async () => {
            if (!customerId) return;

            try {
                const response = await axios.get(`${localurl}/customer/${customerId}`, {
                    headers: {
                        accept: 'application/json',
                    },
                });
                setCustomers(response.data);
            } catch (error) {
                console.error('Error fetching customer details:', error);
            }
        };

        fetchCustomerDetails();
    }, [customerId]);

    // const isActive = activeCustomerIds.includes(customerId);
    const isConnectedToThisChat = isAdminConnected && currentAdminChatId === conversationId;

    // Reset connecting state when connection is established
    useEffect(() => {
        if (isConnectedToThisChat && isConnecting) {
            setIsConnecting(false);
            toast.success('Successfully connected to user!');
        }
    }, [isConnectedToThisChat, isConnecting]);

    // Note: Auto-connection logic has been removed
    // Admin must manually connect using the Connect/Disconnect button
    // This ensures connection only happens when admin explicitly chooses to connect

    const markTicketResolved = async () => {
        try {
            setIsResolving(true);
            await axios.post(
                `${localurl}/escalation/update/status`,
                {
                    ticket_id: chatId,
                    status: 'resolved',
                },
                {
                    headers: {
                        accept: 'application/json',
                    },
                }
            );
            toast.success('Ticket marked as resolved');
            const refreshed = await axios.get(`${localurl}/escalation/chat/details/${chatId}`, {
                headers: {
                    accept: 'application/json',
                },
            });
            setChatDetails(refreshed.data);
        } catch (error) {
            console.error('Error resolving ticket:', error);
            toast.error('Error resolving ticket');
        } finally {
            setIsResolving(false);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${localurl}/active/users`, {
                headers: {
                    accept: 'application/json',
                },
            });
            setUsers(response.data.usernames);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleAssignAgent = async (agent) => {
        try {
            await axios.post(`${localurl}/escalation/update/assign_to`, {
                ticket_id: chatId,
                assign_to: agent,
            }, {
                headers: {
                    accept: 'application/json',
                },
            });
            toast.success(`Agent "${agent}" assigned successfully`);
            setTimeout(() => {
                window.location.reload();
            }, 500);

        } catch (error) {
            console.error('Assignment failed', error);
            toast.error('Failed to assign agent');
        }
    };

    return (
        <div className='w-full'>
            <button onClick={() => navigate(-1)} className="mb-4 text-black bg-white rounded-lg p-4">
                <MdOutlineArrowBackIosNew />
            </button>
            <div className='flex flex-col xl:flex-row gap-2 w-full'>
                <div className='flex flex-col border-2 border-gray-200 rounded-md w-full xl:w-3/4 p-5'>
                    <div className='flex flex-col xl:flex-row justify-between'>
                        <div className='flex flex-col gap-2 w-3/5'>
                            <div className='flex flex-col gap-2'>
                                <p className='text-black text-2xl font-bold'>{chatDetails?.message}</p>
                                <p className='text-gray-400 font-normal text-sm'>
                                    {chatDetails?.created_at && (() => {
                                        const date = new Date(chatDetails.created_at);
                                        const formattedDate = new Intl.DateTimeFormat('en-US', {
                                            month: 'long',
                                            day: 'numeric',
                                            year: 'numeric'
                                        }).format(date);
                                        const formattedTime = new Intl.DateTimeFormat('en-US', {
                                            hour: 'numeric',
                                            minute: '2-digit',
                                            hour12: true
                                        }).format(date);
                                        return `${formattedDate} at ${formattedTime}`;
                                    })()}
                                </p>
                            </div>
                            <div className='flex flex-row gap-2 mt-2'>
                            <div className={`px-2 py-1 rounded-xl text-sm font-medium border-2 flex flex-row items-center gap-1 justify-center h-7
                            ${chatDetails?.priority === "high"
                                    ? "bg-[#FECACA] text-[#B91C1C] border-[#FECACA]"
                                    : chatDetails?.priority === "medium"
                                        ? "bg-[#FED7AA] text-[#C2410C] border-[#FED7AA]"
                                        : chatDetails?.priority === "low"
                                            ? "bg-[#F0FDF4] text-[#15803D] border-[#BBF7D0]"
                                            : ""
                                }`}>
                                <span className="text-md font-extrabold"><FaRegFlag /></span>{chatDetails?.priority}
                            </div>
                            <div className={`p-1 px-2 rounded-full text-sm font-medium border-2 flex flex-row items-center gap-1 justify-center h-7
                            ${chatDetails?.status === "pending"
                                    ? "bg-[#FFFBEB] text-[#B45309] border-[#FDE68A]"
                                    : chatDetails?.status === "in_progress"
                                        ? "bg-[#BFDBFE] text-[#1D4ED8] border-[#BFDBFE]"
                                        : chatDetails?.status === "resolved"
                                            ? "bg-[#F0FDF4] text-[#15803D] border-[#BBF7D0]"
                                            : ""
                                }`}>
                                <span className="text-md font-extrabold"><WiTime4 /></span>{chatDetails?.status}
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-row gap-4 h-9 mt-2'>
                            {/**
                             * Connect/Disconnect admin socket button temporarily hidden per request.
                             * Keeping the code commented to preserve functionality for later use.
                             */}
                            {/**
                            <button
                                className={`md:px-3 p-2 flex flex-row gap-2 items-center text-sm rounded-lg ${isActive
                                    ? isConnectedToThisChat
                                        ? "bg-red-500 text-white"
                                        : isConnecting
                                            ? "bg-yellow-500 text-white"
                                            : "bg-green text-white"
                                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                    }`}
                                disabled={!isActive || isConnecting}
                                onClick={handleAdminSocketToggle}
                            >
                                {isConnecting ? (
                                    <>
                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                        Connecting...
                                    </>
                                ) : isConnectedToThisChat ? "Disconnect" : "Connect"}
                            </button>
                            */}
                            <Dropdown 
                                menu={{ 
                                    items: users.map(username => ({
                                        key: username,
                                        label: username,
                                        onClick: () => handleAssignAgent(username)
                                    }))
                                }} 
                                trigger={['click']} 
                                className=''
                            >
                                <button className=' md:px-3 p-2 flex flex-row gap-2 items-center text-sm rounded-lg bg-green text-white'>
                                    Assign Agent <FaChevronDown />
                                </button>
                            </Dropdown>
                            <button
                                className={`md:px-3 p-2 flex flex-row gap-2 items-center rounded-lg ${chatDetails?.status === 'resolved' || isResolving ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-green text-white text-sm'}`}
                                onClick={markTicketResolved}
                                disabled={chatDetails?.status === 'resolved' || isResolving}
                            >
                                <FaRegCheckCircle /> Resolve
                            </button>
                        </div>
                    </div>

                    <div className='mt-4'>
                        <Tabs
                            className="custom-tabs"
                            defaultActiveKey="1"
                            items={[
                                {
                                    label: (
                                        <span className="flex items-center gap-2 text-black ">
                                            <BiConversation className="text-lg mt-1" />
                                            Conversation
                                        </span>
                                    ),
                                    key: '1',
                                    children: (
                                        chatDetails ? <Editor chatDetails={chatDetails} /> : <p>Loading chat...</p>
                                    ),
                                },
                                {
                                    label: (
                                        <span className="flex items-center gap-2 text-black">
                                            <FaRegChartBar className="text-lg mt-1" />
                                            Activity
                                        </span>
                                    ),
                                    key: '2',
                                    children: (
                                        chatDetails ? <Activity chatDetails={chatDetails} /> : <p>Loading chat...</p>

                                    )
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className='flex flex-col border-2 h-1/4 border-gray-200 w-full xl:w-1/4 rounded-md'>
                    <p className='text-[#09090B] text-2xl font-semibold p-4'>User Information</p>
                    {customers && (
                        <div className="flex items-center px-4 py-2 rounded-xl gap-3 mb-2">
                            <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                                <FaRegUser className="w-5 h-5 text-gray-500" />
                            </div>
                            <div>
                                <div className="flex items-center gap-2">
                                    <span className="font-medium">{customers.ip}</span>
                                    <span className="text-base text-gray-500">{customers.country_flag}</span>
                                    <span className="text-base text-gray-500">
                                        {customers.device === "is_mobile" ? <CiMobile1 /> :
                                            customers.device === "is_tablet" ? <FiTablet /> :
                                                customers.device === "is_desktop" ? <CiLaptop /> :
                                                    customers.device === "is_smart_tv" ? <FaTv /> :
                                                        <GoDependabot />}
                                    </span>
                                    <span className="text-sm text-gray-500">
                                        {customers.browser === "safari" ? <FaSafari /> :
                                            customers.browser === "brave" ? <FaBrave /> :
                                                <FaChrome />}
                                    </span>
                                    <span className="text-sm text-gray-500">
                                        {customers.os === "mac" ? <FaApple /> :
                                            customers.os === "linux" ? <FaLinux /> :
                                                <FaWindows />}
                                    </span>
                                </div>
                                <div className="text-sm text-gray-500">
                                    {customers.city}, {customers.region}, {customers.country}
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
            <Toaster />
        </div>
    )
}

export default ConversationHistory